import { Navigate, useNavigate, useSearchParams } from "react-router";
import { NewClientForm } from "../../components/NewClientForm";
import { NewStandaloneClientHeader } from "../../components/StandaloneClientHeader";
import { themeClass } from "../../lib/platformIdentity";

const neutralTheme = themeClass("neutral");

// The page for a new client that is not in a platform: the standalone client's
// page, with the new client form in the box where the client would be. Arriving
// from a platform (?platformId=<id>) the client belongs to that platform, so it
// is made from the platform's Clients tab.
export default function NewStandaloneClient() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const platformId = searchParams.get("platformId");

  if (platformId) {
    return (
      <Navigate
        to={`/platforms/${platformId}?tab=clients&client=new`}
        replace
      />
    );
  }

  return (
    <div className={`bf-content ${neutralTheme}`}>
      <NewStandaloneClientHeader />
      <div className="bf-page-padding">
        {/* The same 1200px, centred box as a client's. */}
        <div style={{ maxWidth: 1200, marginInline: "auto" }}>
          <NewClientForm
            onCreated={(client) => navigate(`/clients/${client.id}`)}
            onCancel={() => navigate("/clients")}
          />
        </div>
      </div>
    </div>
  );
}
